import { createSlice } from "@reduxjs/toolkit";
import { Comment ,  CommentState} from "./commentTypes";
import {  fetchcommentById , createcomment} from "./commentAction"


const initialState: CommentState = {
 comment: [],
  selectedcomment: undefined,
  loadingStates: {
    create: false,
    update: false,
    delete: false,
    fetchById: false,
    fetchAll: false,
  },
  errors: {
    create: undefined,
    update: undefined,
    delete: undefined,
    fetchById: undefined,
    fetchAll: undefined,
  },
};

const commentSlice = createSlice({
  name: "comment",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchcommentById.pending, (state) => {
        state.loadingStates.fetchById = true;
        state.errors.fetchById = undefined;
      })
      .addCase(fetchcommentById.fulfilled, (state, action) => {
        state.loadingStates.fetchById = false;
        state.selectedcomment = action.payload;
      })
      .addCase(fetchcommentById.rejected, (state, action) => {
        state.loadingStates.fetchById = false;
        state.errors.fetchById = action.payload as string;
      })
      
    .addCase(createcomment.pending, (state) => {
                                       state.loadingStates.create = true;
                                       state.errors.create = undefined;
                                 })
                                   .addCase(createcomment.fulfilled, (state, action) => {
                                       state.loadingStates.create = false;
                                       state.comment.push(action.payload);
                                   })
                                   .addCase(createcomment.rejected, (state, action) => {
                                       state.loadingStates.create = false;
                                       state.errors.create = action.payload as string;
                                   })
  },
});

export default commentSlice.reducer;